import {
	AspectRatioContainer,
	Carousel,
	Image,
	Lentils,
	MediaGalleryArrowButtons,
	MediaGalleryContextProvider,
	MediaGallerySlide,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useOfertasTracker } from '../../helpers/use-ofertas-tracker';
import { CarlineWithOfertas, Oferta } from '../../services/ofertas-service/models/ofertas';
import { COLOR } from '../constant-styles';

const GalleryWrapper = styled.div`
	position: relative;

	@media screen and (max-width: 959px) {
		padding-top: ${(props) => props.theme.size.dynamic0100};

		& > div:first-child {
			height: 50vh !important;
		}
	}

	@media screen and (min-width: 960px) {
		position: absolute;
		top: 0;
		right: 0;
		padding-top: 0;
		width: 50%;
		height: 100%;

		& > div:first-child {
			height: 100% !important;
		}
	}
`;

const LentilsWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: -50px;
	margin-bottom: 50px;

	& > div {
		background-color: ${COLOR.DARK_GREY_70};
	}
`;

export const ImageGallery = ({
	oferta,
	carline,
}: {
	oferta: Oferta;
	carline: CarlineWithOfertas;
}): React.ReactElement => {
	const { trackOfertasButtonClick } = useOfertasTracker();

	const selectImage = (index: number) => {
		trackOfertasButtonClick(`model-image-${index + 1}`, oferta, carline);
	};

	return (
		<GalleryWrapper className="gallery-wrapper">
			<MediaGalleryContextProvider>
				<>
					<AspectRatioContainer ratio="1:1">
						<Carousel hasBorderRadius={false}>
							{oferta.galeria.map((image, i) => (
								<MediaGallerySlide key={i}>
									<Image alt="image" src={image} objectFit="cover" style={{ height: '100%' }} />
								</MediaGallerySlide>
							))}
						</Carousel>
					</AspectRatioContainer>
					<MediaGalleryArrowButtons ariaLabelNext={'Anterior'} ariaLabelPrev={'Siguiente'} />
				</>
				<LentilsWrapper>
					<Lentils onChange={(i) => selectImage(i)} />
				</LentilsWrapper>
			</MediaGalleryContextProvider>
		</GalleryWrapper>
	);
};
